import type { ReactNode } from 'react';

import { useI18n } from 'utils/i18n';

interface Props {
	children: ReactNode;
	required?: boolean;
}

/** Label text, with an asterisk if required. */
export default function LabelText({ children, required }: Props) {
	const { t } = useI18n();

	return required ? (
		<>
			{children}{' '}
			<span
				className="cursor-help"
				// Screen readers announce required/aria-required attributes, the
				// asterisk should not be needed.
				aria-hidden="true"
				title={t('general_field_required_validation_text')}
			>
				*
			</span>
		</>
	) : (
		children
	);
}
LabelText.displayName = 'LabelText';
